import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import headerView from './views/header-view.vue';
import agendaView from './views/agenda-view';
import updatesView from './views/updates-view'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(headerView),
    _createVNode(_unref(agendaView)),
    _createVNode(_unref(updatesView)),
    _createVNode(_component_router_view)
  ], 64))
}
}

})